// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { LanguageContext } from "App";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MDTypography from "components/MDTypography";
import { useContext, useState, useMemo } from "react";
import { SelectedUserContext } from "../../index";
import MDInput from "components/MDInput";
import Select from "react-select";
import Swal from "sweetalert2";
import UserManagementApi from "../../../../../Classes/API/Administration/UserManagementApi";
import { GenderOptions } from "utils/userConstants";
import CreateUserReq from "../../../../../Classes/Models/Requests/Users/CreateUserReq";
import "./style.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CircularProgress } from "@mui/material";
import countryList from "react-select-country-list";

function Index({ setEditMode }) {
  const User = useContext(SelectedUserContext);
  const { translations } = useContext(LanguageContext);
  const [Gender, setGender] = useState(User.gender);
  const [birthdayDate, setBirthdayDate] = useState(User.birthdayDate || "");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: User.name || "",
    address: User.address || "",
    phone: User.number || "",
    foundBy: User.foundBy || "",
    nationalId: User.nationalId || "",
    relativeNumber: User.relativeNumber || "",
    accreditedPartners: User.accreditedPartners || "",
    chronicDiseases: User.chronicDiseases || "",
    sensitivity: User.sensitivity || "",
    medications: User.medications || "",
    nationalityGroup: User.nationalityGroup || "",
    nationality: User.nationality || "",
  });
  const countryOptions = useMemo(() => countryList().getData(), []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const calculateAge = (dateString) => {
    if (!dateString) return null;
    try {
      const birthDate = new Date(dateString);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    } catch (error) {
      return null;
    }
  };

  const handleBirthdayChange = (e) => {
    setBirthdayDate(e.target.value);
  };

  const Age = calculateAge(birthdayDate);

  const EditUserClick = async () => {
    setLoading(true);
    try {
      let editReq = new CreateUserReq();
      editReq.Id = User.id;
      editReq.Nationality = formData.nationality;
      editReq.NationalityGroup = formData.nationalityGroup;
      editReq.Name = formData.name;
      editReq.Address = formData.address;
      editReq.Number = formData.phone;
      editReq.Age = Age || User.age;
      editReq.BirthdayDate = birthdayDate;
      editReq.FoundBy = formData.foundBy;
      editReq.Gender = Gender;
      editReq.NationalId = formData.nationalId;
      editReq.RelativeNumber = formData.relativeNumber;
      editReq.AccreditedPartners = formData.accreditedPartners;
      editReq.ChronicDiseases = formData.chronicDiseases;
      editReq.Sensetivity = formData.sensitivity;
      editReq.Medications = formData.medications;

      let res = await UserManagementApi.EditUser(editReq);
      if (res.status === "Success") {
        Swal.fire({
          title: translations.success || "Success",
          text: res.message,
          icon: "success",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          setEditMode(false);
          window.location.reload();
        });
      } else {
        Swal.fire("Error", res.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "An error occurred while updating user information",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };


  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toISOString().split("T")[0];
    } catch (error) {
      return "";
    }
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "Not set";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return "Invalid date";
    }
  };

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      borderBottom: "1px solid #ced4da",
      borderRadius: 0,
      minHeight: "unset",
      "&:hover": { borderBottom: "2px solid #1976d2" },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0",
    }),
  };

  return (
    <Card sx={{ height: "100%", boxShadow: "none", position: "relative" }}>
      {loading && (
        <MDBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "inherit",
          }}
        >
          <CircularProgress color="info" />
        </MDBox>
      )}

      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pt={2}
        px={2}
      >
        <MDTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {translations.userManagementInfoUserSettingUserInfo}
        </MDTypography>
        <MDTypography variant="body2" color="secondary">
          <Icon
            onClick={() => setEditMode(false)}
            sx={{ cursor: "pointer", "&:hover": { color: "error.main" } }}
          >
            close
          </Icon>
        </MDTypography>
      </MDBox>

      <MDBox p={2}>
        <MDBox className="user-info-grid">
          <MDBox className="info-item" sx={{ borderRadius: 1 }}>
            <MDTypography
              variant="h6"
              fontWeight="bold"
              textTransform="capitalize"
              sx={{ mb: 2 }}
            >
              {translations.userManagementInfoUserSettingUserInfoBirthday ||
                "Birthday Information"}
            </MDTypography>

            {!User.birthdayDate && !birthdayDate && (
              <MDBox
                sx={{
                  backgroundColor: "#fff3cd",
                  p: 2,
                  borderRadius: 1,
                  mb: 2,
                }}
              >
                <MDTypography
                  variant="body2"
                  color="warning.main"
                  fontWeight="medium"
                >
                  ⚠️ Please add your birthday date.
                </MDTypography>
              </MDBox>
            )}

            {User.birthdayDate && (
              <MDBox sx={{ mb: 2 }}>
                <MDTypography
                  variant="body2"
                  color="success.main"
                  fontWeight="medium"
                >
                  Current birthday: {formatDisplayDate(User.birthdayDate)}
                </MDTypography>
              </MDBox>
            )}

            <MDBox sx={{ mb: 2 }}>
              <MDInput
                type="date"
                value={formatDateForInput(birthdayDate)}
                onChange={handleBirthdayChange}
                label={
                  translations.userManagementInfoUserSettingUserInfoBirthday
                }
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>

            {Age !== null && (
              <MDBox sx={{ borderRadius: 1 }}>
                <MDTypography
                  variant="body2"
                  fontWeight="bold"
                  color="secondary"
                >
                  <CalendarTodayIcon /> Age: {Age} years
                </MDTypography>
              </MDBox>
            )}
          </MDBox>

          {/* User ID (readonly) */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoUserId} &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{User.id}
            </MDTypography>
          </MDBox>

          {/* Name */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoName} &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.name}
              id="name"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Phone */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoPhone}: &nbsp;
            </MDTypography>
            <PhoneInput
              country="eg"
              value={formData.phone}
              onChange={(phone) => setFormData({ ...formData, phone })}
              enableSearch={true}
              inputProps={{ id: "phone", name: "phone", required: true }}
              specialLabel=""
            />
          </MDBox>

          {/* Found By */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoFoundBy} &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.foundBy}
              id="foundBy"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Gender */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfogender}: &nbsp;
            </MDTypography>
            <Select
              options={GenderOptions}
              value={GenderOptions.find((opt) => opt.value === Gender)}
              onChange={(e) => setGender(e.value)}
              styles={customSelectStyles}
            />
          </MDBox>

          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementPgTableElementsNationality ||
                "Nationality"}
              : &nbsp;
            </MDTypography>
            <Select
              options={countryOptions}
              value={countryOptions.find(
                (opt) =>
                  opt.label === formData.nationality ||
                  opt.value === formData.nationality,
              )}
              onChange={(e) =>
                setFormData({ ...formData, nationality: e.label })
              }
              styles={customSelectStyles}
            />
          </MDBox>

          {/* National ID */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoNationalID}{" "}
              &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.nationalId}
              id="nationalId"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Relative Number */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoRelativeNumber}
              : &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.relativeNumber}
              id="relativeNumber"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Chronic Diseases */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {
                translations.userManagementInfoUserSettingUserInfoChronicDiseases
              }
              : &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.chronicDiseases}
              id="chronicDiseases"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Sensitivity */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoSensitivity}:
              &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.sensitivity}
              id="sensitivity"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Medications */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementInfoUserSettingUserInfoMedications}:
              &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.medications}
              id="medications"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Address */}
          <MDBox className="info-item">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.userManagementPgTableElementsAddress}: &nbsp;
            </MDTypography>
            <MDInput
              variant="standard"
              value={formData.address}
              id="address"
              onChange={handleInputChange}
              fullWidth
            />
          </MDBox>

          {/* Save Button */}
          <MDBox
            className="info-item"
            justifyContent="flex-end"
            sx={{ gridColumn: "1 / -1", mt: 3 }}
          >
            <button
              onClick={EditUserClick}
              className="btn btn-primary custom-btn"
              disabled={loading}
            >
              Save Changes
            </button>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Index;
